import styled from '@emotion/styled';
import Cols from '__components/Layout/Cols';

export const StyledCols = styled(Cols)`
  align-items: center;
  & p + p {
    margin: 0;
  }
`;

export const StyledCardHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 20px;

  & > :first-of-type {
    flex-shrink: 0;
  }

  p + p {
    margin-top: 0;
  }
`;
